'use client'

import { useAppSelector } from '@app/model/store/client'
import { QuickBookingArticle } from '@widgets/Restaurant/QuickBooking/variants/QuickBookingArticle'
import { isBookingAvailable } from '@shared/lib/booking/domain/providerRegistry'
import type { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'
import contentStyles from '@pages/NewsItem/ui/NewsContent/NewsContent.module.sass'

type Props = {
  restaurantId: number
  initialRestaurant?: TypeMappingRestOutput | null
}

const NewsArticleBooking = ({ restaurantId, initialRestaurant = null }: Props) => {
  const restaurants = useAppSelector((store) => store.pages.news_item.restaurants)
  const restaurant = restaurants?.find((item) => item.id === restaurantId) ?? initialRestaurant

  if (!restaurant?.status.open || !isBookingAvailable(restaurant.booking)) return null

  return <QuickBookingArticle restData={restaurant} className={contentStyles['quick-booking']} />
}

export default NewsArticleBooking
